import React from 'react';
import { connect } from 'react-redux';
//import './HashDemo.css';
import * as actions from '../actions.js';

import {
    Grid,
    PageHeader,
    Row,
    Col,
} from 'react-bootstrap';




function ChainDemo({ }) {
    return (
        <Grid>
            <PageHeader>
                Blockchain Demonstration
            </PageHeader>
            <Row>
                <Col sm={12}>
                    Under Construction
                </Col>
            </Row>
        </Grid>
    );
}

function stateToProps({  }) {
    return {
    };
}
function dispatchToProps(dispatch) {
    return {
    };
}

export default connect(stateToProps, dispatchToProps)(ChainDemo);







// WEBPACK FOOTER //
// ./src/components/ChainDemo.js